import BillingDashboard from '@/models/general/settings/BillingDashboard';
import { formatBillingPeriodValue } from '@/utils/helpers';
import moment from 'moment';

const getDefaultState = () => ({
  billings: [],
  pagination: { current_page: 1 },
  invoiceItems: [],
  invoiceItemsPagination: { current_page: 1 },
});

export default {
  namespaced: true,

  state: () => getDefaultState(),

  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },

    setBillings(state, payload) {
      state.billings = payload.map((b) => {
        b.updated_at = moment(b.updated_at).format('DD/MM/YYYY HH:mm');
        b.periodVal = formatBillingPeriodValue(b);
        return b;
      });
    },

    setPagination(state, payload) {
      state.pagination = payload;
    },

    setInvoiceItems(state, payload) {
      state.invoiceItems = payload;
    },

    setInvoiceItemsPagination(state, payload) {
      state.invoiceItemsPagination = payload;
    },
  },

  actions: {
    async getPaymentHistory({ commit }, query = '') {
      try {
        const { data } = await BillingDashboard.getPaymentHistory(query);

        commit('setBillings', data.data.billings);
        commit('setPagination', data.data.pagination);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        if (ex.response?.data?.code === 301) {
          commit('setPaymentMethods', ex.response.data.data.store_payment_methods);
        }
        commit('setLoading', false, { root: true });
        if (ex.response?.data) console.error(ex.response.data);
      }
    },

    async billingPayment({ commit }, billingId) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await BillingDashboard.billingPayment(billingId);

        commit('setLoading', false, { root: true });

        return data;
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response?.data.message, {
          root: true,
        });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },

    async getInvoiceItemUsages({ commit }, { billingId, invoiceItemId, page }) {
      try {
        const { data } = await BillingDashboard.getInvoiceItemUsages(
          billingId,
          invoiceItemId,
          page
        );

        commit('setInvoiceItems', data.data.invoice_item_usages);
        commit('setInvoiceItemsPagination', data.data.pagination);
        commit('setLoading', false, { root: true });
        return data;
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex.response?.data || 'error');
        return ex.response?.data;
      }
    },
  },
};
